import React from 'react'
import { NavLink } from 'react-router-dom'
import './Menu.css';

const Menu = () => {

    const personal_orientacion = localStorage.getItem('personal_orientacion');
    const personal_prefectura = localStorage.getItem('personal_prefectura');
    const personal_tutoria = localStorage.getItem('personal_tutoria');

    const showMenu = {
        not: {
            display: "none",
        }
    }

    return (
        <div className= "contenedor-menu-prefectos">
            <div>
                <NavLink activeClassName= "activo" to= "/maestros-react/panel/inicio">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Inicio
                        </div>
                    </div>
                </NavLink>
            </div>
            <div style={ personal_prefectura ? {} : showMenu.not}>
                <NavLink activeClassName= "activo-prefectos" to= "/maestros-react/panel/asistencia">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Registro Asistencias
                        </div>
                    </div>    
                </NavLink>
            </div> 
            <div style={ personal_prefectura ? {} : showMenu.not}>
                <NavLink activeClassName= "activo-prefectos" to= "/maestros-react/panel/consulta-asistencia">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Consulta Asistencias
                        </div>
                    </div>    
                </NavLink>
            </div>
            <div style={ personal_prefectura ? {} : showMenu.not}>
                <NavLink activeClassName= "activo-prefectos" to= "/maestros-react/panel/faltas-alumnos">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Alumnos Faltantes
                        </div>
                    </div>    
                </NavLink>
            </div>
            <div style={ personal_prefectura ? {} : showMenu.not}>
                <NavLink activeClassName= "activo-prefectos" to= "/maestros-react/panel/retardos">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Retardos
                        </div>
                    </div>    
                </NavLink>
            </div>
            <div style={ personal_prefectura ? {} : showMenu.not}>
                <NavLink activeClassName= "activo-prefectos" to= "/maestros-react/panel/envio-mensajes">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Envio Mensajes
                        </div>
                    </div>    
                </NavLink>
            </div> 
            <div style={ personal_prefectura ? {} : showMenu.not}>
                <NavLink activeClassName= "activo-prefectos" to= "/maestros-react/panel/reportes">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Reportes de Conducta
                        </div>
                    </div>    
                </NavLink>
            </div>
            <div style={ personal_prefectura ? {} : showMenu.not}>
                <NavLink activeClassName= "activo-prefectos" to= "/maestros-react/panel/justificantes">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Justificantes
                        </div>
                    </div>    
                </NavLink>
            </div>
            <div style={ personal_prefectura ? {} : showMenu.not}>
                <NavLink activeClassName= "activo-prefectos" to= "/maestros-react/panel/informacion">
                    <div className= "contenedor-opc-prefectos">
                        <div className= "opc-prefectos">
                            Informacion Alumno
                        </div>
                    </div>    
                </NavLink>
            </div>
            {/* <div>
                <NavLink activeClassName= "activo" to= "/maestros-react/panel/materias">
                    <div className= "contenedor-opc">
                        <div className= "opc">
                            Materias Oficiales
                        </div>
                    </div>    
                </NavLink>
            </div> 
            <div>
                <NavLink activeClassName= "activo" to= "/maestros-react/panel/faltas">
                    <div className= "contenedor-opc">
                        <div className= "opc">
                            Faltas
                        </div>
                    </div>    
                </NavLink>
            </div>
            <div>
                <NavLink activeClassName= "activo" to= "/maestros-react/panel/materias-optativas">
                    <div className= "contenedor-opc">
                        <div className= "opc">
                            Materias Optativas
                        </div>
                    </div>    
                </NavLink>
            </div>
            <div>
                <NavLink activeClassName= "activo" to= "/maestros-react/panel/faltas-optativas">
                    <div className= "contenedor-opc">
                        <div className= "opc">
                            Faltas Optativas
                        </div>
                    </div>    
                </NavLink>
            </div> */}
        </div>
    );
};

export default Menu;
